(() => {
  if (!['seinakleebised.ee', 'www.seinakleebised.ee'].includes(location.hostname)) return;
  if (document.documentElement.lang.toLowerCase() !== 'et' || window.EEFunnelAnalytics) return;

  const script = document.getElementById('ee-funnel-analytics');
  const events = new Set([
    'ee_storefront_page_viewed',
    'ee_product_page_viewed',
    'ee_cart_page_viewed',
    'ee_cart_drawer_opened',
    'ee_cart_drawer_continue_attempted',
    'ee_cart_name_interacted',
    'ee_cart_name_nonempty',
    'ee_cart_phone_interacted',
    'ee_cart_phone_nonempty',
    'ee_contact_validated',
    'ee_contact_name_validation_error',
    'ee_contact_phone_validation_error',
    'ee_delivery_step_viewed',
    'ee_contact_form_viewed',
    'ee_parcel_selection_verified',
    'ee_delivery_widget_ready',
    'ee_parcel_point_present',
    'ee_checkout_attempted',
    'ee_checkout_blocked_terms',
    'ee_checkout_blocked_missing_parcel',
    'ee_checkout_blocked_empty_cart',
    'ee_checkout_blocked_parcel_sync',
    'ee_checkout_blocked_shipping_method',
    'ee_checkout_blocked_parcel_address',
    'ee_cart_read_timeout',
    'ee_cart_read_network_error',
    'ee_cart_read_http_error',
    'ee_cart_read_response_error',
    'ee_checkout_error',
    'ee_checkout_navigation_requested'
  ]);
  const recorded = new Set();
  let tagged = false;

  const allowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (failure) {
      return false;
    }
  };

  const track = (name, once = false) => {
    if (!events.has(name) || (once && recorded.has(name)) || !allowed()) return false;
    if (typeof window.clarity !== 'function') return false;
    try {
      if (!tagged) {
        window.clarity('set', 'storefront', 'seinakleebised.ee');
        window.clarity('set', 'ee_tracking_version', '2026_10_25_v2');
        window.clarity('set', 'ee_tracking_environment', script?.dataset.environment === 'live' ? 'live' : 'draft');
        tagged = true;
      }
      window.clarity('event', name);
      if (once) recorded.add(name);
      return true;
    } catch (failure) {
      return false;
    }
  };

  window.EEFunnelAnalytics = Object.freeze({track});

  const pageViewed = () => {
    track('ee_storefront_page_viewed', true);
    if (script?.dataset.pageType === 'product') track('ee_product_page_viewed', true);
    if (script?.dataset.pageType === 'cart') track('ee_cart_page_viewed', true);
  };

  let privacyLoadRequested = false;
  let privacyReadyPublished = false;
  const privacyReady = () => {
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return;
    pageViewed();
    if (!privacyReadyPublished) {
      privacyReadyPublished = true;
      document.dispatchEvent(new Event('ee:funnel:privacy-ready'));
    }
  };
  const initializePrivacy = () => {
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') {
      privacyReady();
      return;
    }
    if (privacyLoadRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyLoadRequested = true;
    try {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (!error) privacyReady();
      });
    } catch (failure) {}
  };

  const observeField = event => {
    const input = event.target;
    if (!input?.closest?.('#et-cart-checkout')) return;
    const field = input.id === 'et-cart-name' ? 'name' : input.id === 'et-cart-phone' ? 'phone' : null;
    if (!field) return;
    track('ee_cart_' + field + '_interacted', true);
    if (event.type !== 'focusin' && typeof input.value === 'string' && input.value.trim()) {
      track('ee_cart_' + field + '_nonempty', true);
    }
  };

  const start = () => {
    document.addEventListener('visitorConsentCollected', pageViewed);
    initializePrivacy();
    if (!privacyLoadRequested && !privacyReadyPublished && document.readyState !== 'complete') {
      window.addEventListener('load', initializePrivacy, {once: true});
    }
    document.addEventListener('focusin', observeField, true);
    document.addEventListener('change', observeField, true);
    document.addEventListener('blur', observeField, true);
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form?.id !== 'cart-drawer-form' || !form.dataset.etCheckoutUrl) return;
      if (event.submitter && event.submitter.name !== 'checkout') return;
      track('ee_cart_drawer_continue_attempted');
    }, true);

    const drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof MutationObserver !== 'function') return;
    let wasOpen = false;
    const drawerState = () => {
      const isOpen = drawer.hasAttribute('open') && drawer.getAttribute('aria-hidden') !== 'true';
      if (isOpen && !wasOpen) track('ee_cart_drawer_opened');
      wasOpen = isOpen;
    };
    drawerState();
    const observer = new MutationObserver(drawerState);
    observer.observe(drawer, {attributes: true, attributeFilter: ['open', 'aria-hidden']});
    const onPageHide = event => {
      if (event.persisted) return;
      observer.disconnect();
      window.removeEventListener('pagehide', onPageHide);
    };
    window.addEventListener('pagehide', onPageHide);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
